import { api } from '../../../shared/services/api/client';

export const getDashboardAnalytics = (filter, config = {}) => {
    return api.get('/dashboard/get-analytics', {
        params: { filter },
        ...config,
    });
};

/**
 * GET /api/v1/dashboard/activity-log?limit=10
 * Returns AxiosResponse with payload in .data
 */
export const getActivityLog = (limit = 10, config = {}) => {
    return api.get('/dashboard/activity-log', {
        params: { limit },
        ...config,
    });
};
